const faqs = [
  {
    q: '51吃瓜官网每天都在更新吗？',
    a: '是的！51吃瓜网今日吃瓜频道全天候实时更新，从早到晚覆盖所有热点事件。我们的编辑团队 7x24 小时值班，确保全网最新吃瓜资讯第一时间出现在你面前。每日吃瓜精选更是精挑细选，让你不错过任何一颗"好瓜"。',
  },
  {
    q: '投稿爆料会被泄露身份信息吗？',
    a: '绝对不会。51吃瓜官网采用多层加密和脱敏技术，所有投稿爆料者的个人信息在上传后立即进入加密沙箱。我们坚持吃瓜群众的"匿名权"，平台成立至今从未发生过一起信息泄露事件。你的身份，永远只有你自己知道。',
  },
  {
    q: '51吃瓜官网和其他吃瓜站有什么区别？',
    a: '首先是更新速度——我们的全网最新吃瓜频道在速度上远超同类站点。其次是内容丰富度，图文、视频、深度分析、专题合集一应俱全。最重要的是我们建立了严格的吃瓜资源合集审核机制，确保每一条信息都经过交叉验证后再推送，既快又准。',
  },
  {
    q: '如何下载51吃瓜App？',
    a: '目前51吃瓜App已在各大应用商店上架，支持 iOS 和 Android 双平台。你可以直接在本页上方的"51吃瓜 App 客户端"区域获取下载入口，或扫描页面中的二维码。App 端支持推送通知、夜间模式和离线缓存，体验比网页版更流畅！',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          <i className="ri-question-answer-line text-accent-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 mb-8 text-center">关于51吃瓜网今日吃瓜的常见问题，你想知道的都在这里</p>

        <div className="space-y-3">
          {faqs.map((item, i) => (
            <div key={i} className="bg-background-50 border border-background-200/60 rounded-lg p-5">
              <h3 className="text-sm font-bold text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-heading text-lg leading-none flex-shrink-0">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex items-start gap-2">
                <span className="text-accent-500 font-heading text-lg leading-none flex-shrink-0">A</span>
                <span>{item.a}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}